<template>
  <div>
    <div class="dsh-breadcrumb-layout">
      <div class="dsh-inviterpro w1200" v-if="SpecialList.length > 0">
        <div class="goods-list clearfix">
          <ul>
            <li v-for="(item, index) in SpecialList" :key="index">
              <div class="goods-pic">
                <router-link :to="{path:'/special/detail/' +item.id}">
                  <img class="lazyload" :data-original="item.image" :title="item.title" :src="item.image"
                    :alt="item.title" style="display: inline;" />
                </router-link>
                </a>
              </div>
              <router-link :to="{path:'/special/detail/' +item.id}">
                <div class="goods-name">
                  <a href="javascript:void(0)" title>{{item.title}}</a>
                </div>
              </router-link>
              <div class="goods-info">
                <span class="goods-price" v-if="item.price == '请先登录'">请先登录</span>
                <span class="goods-price" v-else>¥{{item.price}}</span>
                <span class="inviter_amount">
                  &nbsp;
                  <em></em>
                </span>
              </div>
            </li>
          </ul>
        </div>
        <div class="pagination"></div>
      </div>
      <div v-else style="height:680px;">
        <no-record></no-record>
      </div>
    </div>
  </div>
</template>
<script>
  import "@/assets/styles/index.css";
  import noRecord from '@/components/NoRecord.vue'
  import {
    getSpecialList
  } from "@/api/activity";
  export default {
    name: "SpecialList",
    components: {
      noRecord
    },
    props: {},
    data: function () {
      return {
        SpecialList: []
      };
    },
    mounted: function () {
      this.getData();
    },
    methods: {
      getData() {
        var that = this;
        getSpecialList()
          .then(res => {
            that.SpecialList = res.data;
          })
          .catch(res => {
            that.$dialog.error(res.msg);
          });
      }
    }
  };
</script>

<style scoped></style>
